import React from "react";
import {AccessReview, AccessReviewRestControllerApiFactory} from "arteco-api-client-ts";
import {FormContent} from "../../../../components/form/form_inputs/form_buttons";
import {FormInput} from "../../../../components/form/form_inputs/form_input";
import FormAutocomplete from "../../../../components/form/form_inputs/form_autocomplete";
import FormFile from "../../../../components/form/form_inputs/form_file";
import {Alert, Grid} from "@mui/material";
import {useForm, UseFormProps} from "../../../../components/form/form_model";
import {useApiManager} from "../../../../components/utils/api";
import {types} from "../../../../components/form/types";

/**
 * Una revisión de accesos (#13720). Al guardarla nueva se adjunta sola la foto de usuarios y roles
 * de la Extranet, Gitea o Redmine según el sistema revisado (#13849).
 */
export const AccessReviewEditPage = () => {
	const apiManager = useApiManager();
	const ctrl = apiManager.factory(AccessReviewRestControllerApiFactory);

	const form = useForm({
		fetcher: (id) => ctrl.getAccessReview(id),
		updater: (bean) => ctrl.saveAccessReview(bean),
		remover: (id) => ctrl.deleteOrDismissAccessReview(id),
		factory: () => ({
			reviewDate: new Date().toISOString().substring(0, 10),
			scope: "Extranet",
		} as AccessReview),
		// Al crearla, el servidor le adjunta la foto y cuenta los usuarios. Guardar no repinta los
		// campos ya montados, así que se les empujan los valores que vuelven.
		postUpdate: (bean: AccessReview) => setTimeout(() => {
			form.triggerField("attachment", bean.attachment);
			form.triggerField("usersReviewed", bean.usersReviewed);
		}, 0),
	} as UseFormProps<AccessReview>);

	return (
		<FormContent form={form} title={"Revisión de accesos"}>
			{!form.getId() && (
				<Alert severity="info" sx={{mb: 2}}>
					Si el sistema revisado es Extranet, Gitea o Redmine, al guardarla se adjunta sola la foto
					de sus cuentas de este momento. Para otro sistema (Logto, Google Workspace, el clúster),
					escribe su nombre y adjunta su listado.
				</Alert>
			)}
			<Grid container spacing={2}>
				<Grid item xs={12} sm={3}>
					<FormInput field={"reviewDate"} type={"date"} label={"Fecha"}/>
				</Grid>
				<Grid item xs={12} sm={3}>
					<FormInput field={"scope"} label={"Sistema revisado"} helperText={"Extranet, Gitea, Redmine u otro"}/>
				</Grid>
				<Grid item xs={12} sm={3}>
					<FormAutocomplete field={"reviewer"} label={"Revisado por"} type={types.people}/>
				</Grid>
				<Grid item xs={12} sm={3}>
					<FormInput field={"nextReviewDate"} type={"date"} label={"Próxima revisión"}/>
				</Grid>
				<Grid item xs={12} sm={3}>
					<FormInput field={"usersReviewed"} type={"number"} label={"Usuarios revisados"}/>
				</Grid>
			</Grid>
			<FormInput field={"findings"} label={"Qué se encontró"} rows={3}
					   helperText={"Usuarios sin persona activa, roles de más, cuentas sin uso"}/>
			<FormInput field={"changes"} label={"Qué se cambió"} rows={3}/>
			<FormFile field={"attachment"} label={"Foto de usuarios y roles"}
					  onDownload={() => apiManager.executeRaw(ctrl.viewAccessReview(form.getIdOrErr()))}/>
		</FormContent>
	);
};
